<template>
  <main class="main">
    <ol class="breadcrumb-trail__list">
      <li class="breadcrumb-trail__list--item">
        <router-link
          :to="{ path: `/${langPath}` }"
          class="breadcrumb-trail__list--item__link"
        >
          TOP
        </router-link>
      </li>
      <li class="breadcrumb-trail__list--item">
        <router-link
          :to="{ path: `/${langPath}howtojoin` }"
          class="breadcrumb-trail__list--item__link"
        >
          How to Join
        </router-link>
      </li>
    </ol>
    <h1 class="how-to-join-title">How to Join</h1>
    <h2 class="about-title">
      {{ HowToJoin.aboutTitle[lang] }}
    </h2>
    <p class="about-virtualrun">
      {{ HowToJoin.about[lang] }}
    </p>
    <h2 class="howtojoin-flow">
      {{ HowToJoin.participationFlow[lang] }}
    </h2>
    <ol>
      <li class="flow__list--item">
        <div class="title-area">
          <h3 class="step-title">STEP 1</h3>
          <p class="status-label">{{ HowToJoin.step1.flow[lang] }}</p>
        </div>
        <h4 class="flow-title">{{ HowToJoin.step1.title[lang] }}</h4>
        <div class="detail-area">
          <img
            class="flow-img"
            src="../../../assets/images/flow/step_01.svg"
            alt="Download the App"
            width="160px"
            height="160px"
          />
          <div>
            <h5 class="suggestion">
              {{ HowToJoin.step1.suggestion[lang] }}
            </h5>
            <p class="important-points">
              {{ HowToJoin.step1.point[lang]
              }}<router-link
                v-scroll-to="'#app-use-list'"
                to=""
                class="t-underline"
                >{{ HowToJoin.here[lang] }}
              </router-link>
              {{ HowToJoin.step1.point2[lang] }}
            </p>
          </div>
        </div>
      </li>
      <li class="flow__list--item">
        <div class="title-area">
          <h3 class="step-title">STEP 2</h3>
          <p class="status-label">{{ HowToJoin.step2.flow[lang] }}</p>
        </div>
        <h4 class="flow-title">{{ HowToJoin.step2.title[lang] }}</h4>
        <div class="detail-area">
          <img
            class="flow-img"
            src="../../../assets/images/flow/step_02.svg"
            alt="Enter To an Event"
            width="160px"
            height="160px"
          />
          <div>
            <h5 class="suggestion">
              {{ HowToJoin.step2.suggestion[lang] }}
            </h5>
            <p class="important-points">
              {{ HowToJoin.step2.point[lang]
              }}<router-link
                :to="{ path: `/${langPath}`, query: { from: 'htj' } }"
                class="t-underline"
                >{{ HowToJoin.here[lang] }}
              </router-link>
            </p>
          </div>
        </div>
      </li>
      <li class="flow__list--item">
        <div class="border-important" :class="`height-${lang}`"></div>
        <p class="important flex-all-center">
          {{ HowToJoin.step3.important[lang] }}
        </p>
        <div class="title-area">
          <h3 class="step-title">STEP 3</h3>
          <p class="status-label">{{ HowToJoin.step3.flow[lang] }}</p>
        </div>
        <h4 class="flow-title">{{ HowToJoin.step3.title[lang] }}</h4>
        <div class="detail-area">
          <img
            class="flow-img"
            src="../../../assets/images/flow/step_03.svg"
            alt="Sync your account of the downloaded app to the event."
            width="160px"
            height="160px"
          />
          <div>
            <h5 class="suggestion">
              {{ HowToJoin.step3.suggestion[lang] }}
            </h5>
            <p class="important-points">
              <span v-html="HowToJoin.step3.point[lang]"></span>
              <span class="color-red">
                {{ HowToJoin.step3.appLinkSetting[lang]
                }}<a
                  :href="HowToJoin.step3.pdf[lang]"
                  target="_blank"
                  rel="noopener"
                  class="color-red t-underline ga-flow"
                  >{{ HowToJoin.here[lang] }}</a
                >
                {{ HowToJoin.step3.appCoopConfirm[lang]
                }}<a
                  :href="HowToJoin.step3.pdf2[lang]"
                  target="_blank"
                  rel="noopener"
                  class="color-red t-underline ga-flow"
                  >{{ HowToJoin.here[lang] }}</a
                >
              </span>
            </p>
          </div>
        </div>
      </li>
      <li class="flow__list--item">
        <div class="title-area">
          <h3 class="step-title">STEP 4</h3>
          <p class="status-label">{{ HowToJoin.step4.flow[lang] }}</p>
        </div>
        <h4 class="flow-title">{{ HowToJoin.step4.title[lang] }}</h4>
        <div class="detail-area">
          <img
            class="flow-img"
            src="../../../assets/images/flow/step_04.svg"
            alt="Getting Ready for the Race"
            width="160px"
            height="160px"
          />
          <div>
            <h5 class="suggestion">{{ HowToJoin.step4.title[lang] }}</h5>
            <h6 class="verification">
              {{ HowToJoin.step4.verification[lang] }}
            </h6>
            <p class="verification__sentence">
              {{ HowToJoin.step4.verificationNote[lang] }}
              <br />
              {{ HowToJoin.step4.verificationNote2[lang] }}
            </p>
            <h6 class="verification">
              {{ HowToJoin.step4.verification2[lang] }}
            </h6>
            <p class="verification__sentence">
              {{ HowToJoin.step4.verification2Note[lang] }}
              <br />
              {{ HowToJoin.step4.verification2Note2[lang] }}
            </p>
          </div>
        </div>
      </li>
      <li class="flow__list--item">
        <div class="title-area">
          <h3 class="step-title">STEP 5</h3>
          <p class="status-label">{{ HowToJoin.step5.flow[lang] }}</p>
        </div>
        <h4 class="flow-title">{{ HowToJoin.step5.title[lang] }}</h4>
        <div class="detail-area">
          <img
            class="flow-img"
            src="../../../assets/images/flow/step_05.svg"
            alt=""
            width="160px"
            height="160px"
          />
          <div>
            <h5 class="suggestion">
              {{ HowToJoin.step5.suggestion[lang] }}
            </h5>
            <p
              class="important-points pre-line-normal"
              v-for="(point, index) in HowToJoin.step5.points"
              :key="index"
            >
              {{ point[lang] }}
            </p>
          </div>
        </div>
      </li>
      <li class="flow__list--item">
        <div class="title-area">
          <h3 class="step-title">STEP 6</h3>
          <p class="status-label">{{ HowToJoin.step6.flow[lang] }}</p>
        </div>
        <h4 class="flow-title">{{ HowToJoin.step6.title[lang] }}</h4>
        <div class="detail-area">
          <img
            class="flow-img"
            src="../../../assets/images/flow/step_06.svg"
            alt=""
            width="160px"
            height="160px"
          />
          <div>
            <h5 class="suggestion">
              {{ HowToJoin.step6.suggestion[lang] }}
            </h5>
            <p class="important-points">{{ HowToJoin.step6.point[lang] }}</p>
          </div>
        </div>
      </li>
    </ol>
    <h2 id="app-use-list" class="app-to-use">
      {{ HowToJoin.runApp[lang] }}
    </h2>
    <p class="app-description">{{ HowToJoin.runAppExplanation[lang] }}</p>
    <div class="app-gallery">
      <img
        class="app-gallery__img"
        src="../../../assets/images/app/runkeeper-app-logo.png"
        alt=""
        width="150"
        height="150"
      />
      <div>
        <div class="app-gallery__title">ASICS Runkeeper™</div>
        <div class="app-gallery__link">
          <a :href="HowToJoin.appStore[lang]" target="_blank" rel="noopener">
            <img
              src="../../../assets/images/app/runkeeper-ios.svg"
              alt="Download on the App Store"
            />
          </a>
          <a
            :href="HowToJoin.googlePlay[lang]"
            class="app-gallery__link--android"
            target="_blank"
            rel="noopener"
          >
            <img
              src="../../../assets/images/app/runkeeper-android.png"
              alt="Get it on Google Play"
              height="62"
            />
          </a>
        </div>
      </div>
    </div>
    <h2 class="important-title">{{ HowToJoin.importantNote[lang] }}</h2>
    <ol class="important-list">
      <li
        v-for="(importantNote, index) in HowToJoin.importantNotes"
        :key="index"
        class="important-list__item"
      >
        {{ importantNote[lang] }}
      </li>
    </ol>
  </main>
</template>

<script>
import HowToJoin from "../../../assets/constants/howtojoin/howtojoin.json";

export default {
  computed: {
    HowToJoin: function () {
      return HowToJoin;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  name: "HowToJoin",
};
</script>

<style scoped lang="scss">
$pageColor: #ffbc00;
$backgroundColor: #eee;
h2 {
  font-size: 50px;
}
h3 {
  font-size: 40px;
  line-height: 1;
}
h4 {
  font-size: 40px;
  line-height: 1.17;
}
h5 {
  font-size: 22px;
  line-height: 1.27;
}
h6 {
  font-size: 18px;
  line-height: 1.56;
}
.main {
  text-align: center;

  .how-to-join-title {
    display: inline-block;
    margin: 96px 0 0 0;
    padding: 0;
    line-height: 1;
    font-size: 100px;
    font-weight: 900;
    &::after {
      content: "";
      display: block;
      height: 10px;
      background: url("../../../assets/images/border/border_howto.svg");
      margin-top: 8px;
    }
  }

  .about-title {
    margin: 124px 0 0 0;
  }

  .about-virtualrun {
    margin: 68px 0 0 0;
    line-height: 1.55;
    font-size: 22px;
    text-align: left;
  }

  .howtojoin-flow {
    margin: 124px 0 0 0;
  }

  .flow__list--item {
    padding: 20px 0 42px 4px;
    border-bottom: solid 1px #000;
    text-align: left;
    position: relative;
    &:not(:first-of-type) {
      .title-area {
        margin: 50px 0 0 0;
        position: relative;

        &::before {
          content: "";
          display: inline-block;
          width: 60px;
          height: 30px;
          background: url("../../../assets/images/triangle-bottom.png")
            no-repeat center / 60px 30px;
          position: absolute;
          top: -50px;
          left: 50%;
          transform: translate(-50%);
        }
      }
    }
    /*「重要対応」*/
    &:nth-of-type(3) {
      .title-area {
        margin: 90px 0 0 0;
        &::before {
          top: -90px;
        }
      }
    }
    .border-important {
      width: 100%;
      height: 538px;
      border: solid 1px $pageColor;
      position: absolute;
      top: 70px;
      left: 50%;
      transform: translateX(-50%);
      z-index: -1;
    }
    .height-en {
      height: 612px;
    }
    .important {
      width: 140px;
      height: 30px;
      position: absolute;
      top: 70px;
      left: 0;
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      background-color: $pageColor;
    }
    .title-area {
      display: flex;
      align-items: center;
      margin: 43px 0 0 0;

      .step-title {
        margin: 0 13px 0 0;
        position: relative;
        &::after {
          content: "";
          display: inline;
          width: 40px;
          height: 5px;
          margin: 4px 0 0 0;
          background-color: $pageColor;
          position: absolute;
          top: 100%;
          left: 0;
        }
      }

      .status-label {
        display: inline-block;
        padding: 11px 17px;
        border: solid 1px #000;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .flow-title {
      margin: 30px 0 0 0;
    }
    .detail-area {
      display: flex;
      align-items: center;
      margin: 25px 0 0 0;

      .flow-img {
        margin: 0 13px 0 0;
      }

      .important-points {
        line-height: 1.5;
        white-space: pre-line;
        &:first-of-type {
          margin: 14px 0 0 0;
        }
      }

      .pre-line-normal {
        white-space: normal;
      }

      .verification {
        margin: 13px 0 0 0;
        padding: 0 0 0 6px;
        border-left: solid 5px #000;
        &__sentence {
          margin: 11px 0 0 0;
          line-height: 1.5;
          font-size: 16px;
        }
      }
    }
  }

  /*スクロールした時の余白を保つために分けてる*/
  .app-to-use {
    margin: 100px 0 0 0;
    padding: 24px 0 0 0;
  }

  .app-description {
    margin: 68px 0 0 0;
    line-height: 1.5;
    font-size: 22px;
    text-align: left;
    white-space: pre-line;
  }

  .app-gallery {
    display: inline-flex;
    align-items: center;
    margin: 43px 0 0 0;
    padding: 38px 14px 34px 31px;
    background-color: $backgroundColor;

    &__img {
      margin: 0 30px 0 0;
    }

    &__title {
      line-height: 1.2;
      font-size: 50px;
      font-weight: 900;
      text-align: left;
    }

    &__link {
      margin: 17px 0 0 0;
      display: flex;
      align-items: center;
      &--android {
        margin: 0 0 0 13px;
      }
    }
  }
  .important-title {
    margin: 124px 0 0 0;
  }
  .important-list {
    margin: 68px 0 0 0;
    line-height: 2;
    font-weight: 500;
    text-align: left;
    &__item {
      &:nth-of-type(3),
      &:nth-of-type(4),
      &:nth-of-type(8),
      &:nth-of-type(9),
      &:nth-of-type(10),
      &:nth-of-type(11) {
        padding: 0 0 0 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/howtojoin/CommonHowToJoin.vue